module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.boxConfig.progressbar.kind === 'mask') ? _c('li', {
    staticClass: "mask",
    staticStyle: {
      "left": "50px",
      "opacity": "1",
      "background": "transparent"
    },
    style: (_vm.getLiStyle())
  }) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-36428dd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/numeric/Mask.vue
 ** module id = 800
 ** module chunks = 1
 **/